import React, { /*useCallback,*/ useEffect, useState } from "react";
import { Link, Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import ProfileImage from "../../Components/ProfileImage";
import ProfileDetails from "../../Components/ProfileDetails";
import { RiderModel } from "../../Api/Models/rider.model";
import { useLoading } from "../../Context/LoadingProvider";
import { useInfoModal } from "../../Context/InfoModalProvider";
import { riderService } from "../../Api/Services/RiderService";
import { useTranslation } from "react-i18next";
import { useUser } from "../../Context/UserProvider";
import UserNavigation from "../UserNavigation";
import defaultRiderAvatar from "../../Assets/gfx/rider_avatar.webp";
import { DotsIcon } from "../../Components/Icons/DotsIcon";
import { BagIcon } from "../../Components/Icons/BagIcon";
import { HomeIcon } from "../../Components/Icons/HomeIcon";
import { SearchIcon } from "../../Components/Icons/SearchIcon";
//import { StarIcon } from "../../Components/Icons/StarIcon";

interface RiderProfileLayoutProps {}

export interface RiderProfileLayoutContextInterface {
  setPageTitle: CallableFunction;
  rider: RiderModel;
  setRider: CallableFunction;
  showTabsNavbar: boolean;
  setShowTabsNavbar: CallableFunction;
  setHasGear: CallableFunction;
  setGearExchangeRequired: CallableFunction;
  setSubTitle: CallableFunction;
  subTitle: string;
  setGearMissing: CallableFunction;
  fetchRider: CallableFunction;
  assignNewGearItem: boolean;
  setAssignNewGearItem: React.Dispatch<React.SetStateAction<boolean>>;}

const RiderProfileLayout: React.FunctionComponent<
  RiderProfileLayoutProps
> = () => {
  const { t } = useTranslation();

  //const [title, setTitle] = useState<string>();
  const [subTitle, setSubTitle] = useState<string>(t("Gear Owned by the Rider") ?? "");
  const [showTabsNavbar, setShowTabsNavbar] = useState<boolean>(true);
  const [hasGear, setHasGear] = useState<boolean>(true);
  const [gearMissing, setGearMissing] = useState<number | null>(null);
  const [gearExchangeRequired, setGearExchangeRequired] =
    useState<boolean>(false);
  const { startLoading, finnishLoading } = useLoading();

  let { riderId } = useParams();
  const { state } = useLocation();
  const [rider, setRider] = useState<RiderModel>(state?.riderModel);
  const { showInfo } = useInfoModal();
  const navigate = useNavigate();
  const { user } = useUser();

    const [assignNewGearItem, setAssignNewGearItem] = useState<boolean>(false);

  useEffect(() => {
    if (!rider) {
      if (!riderId) {
        showInfo(t("Invalid QR code"));
        navigate("/menu");
        return;
      }

      fetchRider();
    }
    //eslint-disable-next-line
  }, []);

  const fetchRider = () => {
    if (!riderId) {
      showInfo(t("Invalid QR code"));
      navigate("/menu");
      return;
    }
    startLoading("get-rider");

    riderService
      .get(riderId)
      .then((rider) => {
        setRider(rider);
      })
      .catch((e) => {
        showInfo(t("Invalid QR code"));
        navigate("/menu");
      })
      .finally(() => {
        finnishLoading("get-rider");
      });
  };

  //const setPageTitle = useCallback(
  //  (titleToBeSet: string) => setTitle(titleToBeSet),
  //  []
  //);

  const [showRiderMenuModal, setShowRiderMenuModal] =
    useState<boolean>(false);

  return (
    <>
      <div className="view-container view-container--stretch background">
        <div className="view-content h-full flex flex-col justify-between">
          <div>
            <div className="navigationbar mb-6">
              <div className="navigationbar__left">
                <Link to="/menu" className="navigationbar__button">
                  <HomeIcon />
                </Link>
                <Link to="/rider/search" className="navigationbar__button">
                  <SearchIcon width={20} height={20} />
                </Link>
              </div>
              <div className="navigationbar__center"></div>
              <div className="navigationbar__right">
                <UserNavigation />
              </div>
            </div>
          </div>

          {/*{title ? <div className="heading text-center">{title}</div> : null}*/}
          {rider && (
            <>
              <div className="inner-view-container">
                
                <div className="rider-profile-header">
                  <div className="rider-profile-header__left"></div>
                  <div className="rider-profile-header__center">

                  {(rider.image) ?
                    <ProfileImage
                      imageUrl={rider.image}
                      changeImage={!user?.permissions?.includes("app_user.view_only")}
                      showRiderId={false}
                      riderId={rider.riderId}
                    />
                  :
                  <ProfileImage
                      imageUrl={defaultRiderAvatar}
                      changeImage={!user?.permissions?.includes("app_user.view_only")}
                      showRiderId={false}
                      riderId={rider.riderId} 
                    />
                  }

                  </div>
                  <div className="rider-profile-header__right">
                    <div onClick={() => setShowRiderMenuModal(true)}><DotsIcon /></div>
                  </div>
                </div>


                <div className="inner-view-content background-white" style={{paddingTop: '10px'}}>
                  
                    <ProfileDetails
                      rider={rider}
                      hasGear={hasGear}
                      gearMissing={gearMissing}
                      gearExchange={gearExchangeRequired}
                    />
                  
                </div>

                <div className="content-padding background-white" style={{paddingTop: '15px'}}>  
                  <Outlet
                    context={{
                      //setPageTitle,
                      rider,
                      setRider,
                      showTabsNavbar,
                      setShowTabsNavbar,
                      setHasGear,
                      setGearExchangeRequired,
                      subTitle,
                      setSubTitle,
                      setGearMissing,
                      fetchRider,
                      setAssignNewGearItem,
                      assignNewGearItem,
                    }}
                  />
                </div>
              </div>
              
            </>
          )}
        </div>
      </div>

      <div
        className={"modal modal--with-closebar " + (showRiderMenuModal ? "" : "hidden")}
        tabIndex={-1}
        aria-modal="true"
        role="dialog"
      >
        <div className="modal__dialog">
          <div className="modal__closebar" onClick={() => setShowRiderMenuModal(false)}></div>
          <div className="modal__body">
             <div className="text-secondary mb-4">
                {t("Rider menu")}
              </div>
            <ul className="modal__list">
              <li>
                <div className="flex items-center justify-between">
                  {user?.permissions?.includes("app_user.assign_new_gear_item") &&
                  !user?.permissions?.includes("app_user.view_only") ? (
                  <div
                    className="flex items-center gap-2"
                    onClick={() => {
                      setAssignNewGearItem(true);
                      setShowRiderMenuModal(false);
                    }}
                  >
                    <BagIcon />
                    {t("Add historical gear data")}
                  </div>
                    ) : (
                        <></>
                    )}

                  <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg" className="rtl-hide">
                    <path d="M1 11L4.50024 6.6247C4.79242 6.25948 4.79242 5.74052 4.50024 5.3753L0.999999 1" stroke="#3F4067" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>

                  <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg" className="rtl-show">
                    <g transform="matrix(-1,0,0,1,5.71937,0)">
                      <path d="M1,11L4.5,6.625C4.792,6.259 4.792,5.741 4.5,5.375L1,1" stroke="#3F4067" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                  </svg>
                </div>
              </li>
{/* TODO: ez a funkció egyelőre nincs
              <li>
                <div className="flex items-center justify-between">
                  <div
                    className="flex items-center gap-2"
                    onClick={() => {
                      
                    }}
                  >
                    <StarIcon />
                    {t("Rate rider")}
                  </div>

                  <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg" className="rtl-hide">
                    <path d="M1 11L4.50024 6.6247C4.79242 6.25948 4.79242 5.74052 4.50024 5.3753L0.999999 1" stroke="#3F4067" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>

                  <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg" className="rtl-show">
                    <g transform="matrix(-1,0,0,1,5.71937,0)">
                      <path d="M1,11L4.5,6.625C4.792,6.259 4.792,5.741 4.5,5.375L1,1" stroke="#3F4067" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                  </svg>
                </div>
              </li>
*/} 
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default RiderProfileLayout;
